import { Navigate } from 'react-router-dom';

import { useAppSelector } from '~/store';
import { navigationSelector } from '~/store/selectors/navigationSelectors';

import ClanHub from '~/pages/ClanHub/ClanHub';

import { ROUTES_MAP } from '../routes';

const RootRedirect = () => {
  const { currentAccount, isClanHubEnabled } = useAppSelector(navigationSelector);

  if (isClanHubEnabled) {
    return <ClanHub />;
  }

  if (!currentAccount.clanId) {
    return <Navigate to={ROUTES_MAP.ABOUT} replace />;
  }

  return <Navigate to={ROUTES_MAP.PROFILE} replace />;
};

export default RootRedirect;
